<template>
    <div class="row">
        <div class="col-sm">
            <div class="card-body">
                <form class="default-form" @submit="deleteItemSubmit" novalidate>
                    <div class="form-group">
                        <label>Proizvod</label>
                        <b-form-select v-model="selectedItem" :options="items">
                            <template #first>
                                <b-form-select-option :value="null" disabled>Odaberi proizvod (ID - Naziv)</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                    <button type="submit" class="btn btn-primary">Obirsi</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'


    export default {
        name: 'AdminDeleteItem',
        data() {
            return {
                selectedItem: null
            }
        },
        computed: {
            ...mapGetters([
                'isFetchingItems',
                'getItems'
            ]),

            items: {
                get() {
                    return this.getItems.map(item => {
                        return {
                            text: `${item.id} - ${item.name}`,
                            value: item
                        }
                    })
                }
            }
        },
        methods: {
            ...mapActions([
                'deleteItemById'
            ]),

            deleteItemSubmit(e) {
                e.preventDefault()

                if (this.selectedItem === null) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greska u brisanju proizvoda',
                        text: 'Proizvod nije odabran!'
                    })
                } else {
                    this.deleteItemById(this.selectedItem.id)
                    this.selectedItem = null
                }
            }
        }
    }
</script>

<style scoped>
    .default-form button {
        width: 200px;
        margin-right: 10px;
        margin-bottom: 10px;
    }
</style>